import React from "react";
import {
  TextField,
  BooleanField,
  FunctionField,
  ReferenceField,
} from "react-admin";
import CopyButton from "../../components/CopyButton";
import { BackToOrgButton } from "../../components/Organization/OrgButtons.js";
import useUser from "../../hooks/useUser";
import RenameTextField from "../../components/RenameTextField";
import TriggerZoneButton from "../../components/Zone/TriggerZoneButton";

const ZoneInfoCard = (controllerProps) => {
  const { organization_id, zoneAlerts, id: zoneId } = controllerProps;

  const user = useUser();

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "2rem",
  };

  const tdStyle = {
    padding: "12px",
    borderBottom: "1px solid #ddd",
  };

  const labelStyle = {
    fontWeight: "bold",
  };

  return (
    <table style={tableStyle}>
      <tbody>
        <tr>
          <td style={{ gridColumn: "span 2" }}>
            <BackToOrgButton organization_id={organization_id} />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Name:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="name" />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Zone ID:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="customID" />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Message Type:</span>
          </td>
          <td style={tdStyle}>
            <RenameTextField
              {...controllerProps}
              source="message_prefix"
              types={zoneAlerts}
              target="message"
            />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Message:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="message" />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Notes:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="notes" />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Serial #:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="serialNo" />
          </td>
        </tr>
        <tr>
          <td style={tdStyle}>
            <span style={labelStyle}>Panel ID:</span>
          </td>
          <td style={tdStyle}>
            <TextField source="panel_id" />
          </td>
        </tr>
        <tr>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <span style={labelStyle}>Disable MutualLink:</span>
          </td>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <BooleanField source="mutualink_disabled" />
          </td>
        </tr>
        <tr>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <span style={labelStyle}>Organization:</span>
          </td>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <ReferenceField
              source="OrganizationId"
              reference="organizations"
              link="show"
            >
              <TextField source="name" />
            </ReferenceField>
          </td>
        </tr>
        <tr>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <span style={labelStyle}>Address:</span>
          </td>
          <td style={{ gridColumn: "span 2", ...tdStyle }}>
            <FunctionField
              render={(record) =>
                record.address_line_1
                  ? `${record.address_line_1}, ${
                      record.address_line_2 ? record.address_line_2 + "," : ""
                    } ${record.address_city} ${record.address_state} ${
                      record.address_zip
                    }`
                  : ""
              }
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default ZoneInfoCard;
